module.exports = __webpack_public_path__ + "assets/pluseSignBig-d631cb.svg";